﻿import {ValidationMessage} from "./validationMessage";

export class ValidationMessageHelper {
    static areEqual(vm1: ValidationMessage, vm2: ValidationMessage): boolean {
        return vm1 === vm2 ||
        (!vm1 &&
            vm1.message === vm2.message &&
            !vm1.propertyName &&
            vm1.propertyName === vm2.propertyName &&
            (!vm1.entityId || vm1.entityId === vm2.entityId));
    }

    static hasMessage(vms: ValidationMessage[], vm: ValidationMessage): boolean {
        if (!vms || !vm || vms.length <= 0) {
            return false;
        }
        return vms.filter(( s ) => ValidationMessageHelper.areEqual(s, vm)).length > 0;
    }

    static removeMessage(vms: ValidationMessage[], vm: ValidationMessage): ValidationMessage[] {
        if (!vm || !vms || vms.length <= 0) {
            return vms;
        }
        var indices: number[] = [];
        vms.forEach((s, i) => { if (ValidationMessageHelper.areEqual(s, vm)) indices.push(i) });
        indices.forEach((i) => vms.splice(i, 1));
        return vms;
    }

    static removeMessagesByPropertyName(vms: ValidationMessage[], propName: string): ValidationMessage[] {
        if (!propName || !vms || vms.length <= 0) {
            return vms;
        }
        vms.filter(( s ) => s.propertyName === propName).forEach(( s ) => ValidationMessageHelper.removeMessage(vms, s));
        return vms;
    }
}